var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NebulaBlockMessage',_vm._b({staticClass:"careers-block-message",attrs:{"icon":"warning--filled"}},'NebulaBlockMessage',_vm.boundProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }